import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from "react-bootstrap";
import { startBulkDeleteTasks, startBulkRemoveTasks } from './store/actions/tasks';

export class ActionsDropdown extends React.Component {
  static propTypes = {
    selectedTaskIds: PropTypes.array.isRequired,
    onBulkDeleteTasks: PropTypes.func.isRequired,
    onBulkRemoveTasks: PropTypes.func.isRequired,
    onDeleteCallList: PropTypes.func.isRequired,
    onRenameCallList: PropTypes.func.isRequired
  };

  render() {
    const {
      selectedTaskIds,
      onBulkDeleteTasks,
      onBulkRemoveTasks,
      onRenameCallList,
      onDeleteCallList
    } = this.props;

    const itemsForSelections = selectedTaskIds.length > 0;

    return (
      <Dropdown
        className="actions-dropdown filter mr-3"
        key="call-list-actions-dropdown"
        name="call-list-actions-dropdown"
      >
        <Dropdown.Toggle className="btn btn-default">
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {itemsForSelections &&
            <React.Fragment>
              <MenuItem id='remove-tasks' key='remove-tasks' onClick={onBulkRemoveTasks}>
                Remove Task(s) From Call List
              </MenuItem>
              <MenuItem id='delete-calls' key='delete-calls' onClick={onBulkDeleteTasks}>
                Delete Task(s)
              </MenuItem>
            </React.Fragment>
          }
          <MenuItem id='rename-call-list' key='rename-call-list' onClick={onRenameCallList}>
            Rename Call List
          </MenuItem>
          <MenuItem id='delete-call-list' key='delete-call-list' onClick={onDeleteCallList}>
            Delete Call List
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => ({
  selectedTaskIds: state.selectList.selectedTaskIds
});

const mapDispatchToProps = {
  onBulkDeleteTasks: startBulkDeleteTasks,
  onBulkRemoveTasks: startBulkRemoveTasks
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionsDropdown);